<template>
  <v-container
    fluid
    class="pa-0 fill-height d-flex align-center justify-center"
    style="background-color: #FFF7CC;"
  >
    <v-btn
      fab
      dark
      small
      color="black"
      class="cerrar-boton-container"
      @click="irMenuInge"
    >
      <v-icon>mdi-close</v-icon>
    </v-btn>

    <v-card
      class="pa-6"
      tile
      elevation="2"
      width="100%"
      max-width="1400px"
      style="background-color: transparent;"
    >
      <v-card-title class="justify-center text-h5" style="color: #6c5c01;"></v-card-title>

      <v-row justify="center">
        <v-col
          v-for="item in botones"
          :key="item.titulo"
          cols="12"
          sm="6"
          md="4"
          lg="2"
          class="d-flex justify-center"
        >


          <!-- <v-sheet
            class="boton-cuadrado"
            :color="item.color"
            elevation="6"
            rounded
            @click="irA(item.ruta)"
          >
            <div class="contenido-boton text-center">
              <v-icon size="36" class="mb-2" color="white">{{ item.icon }}</v-icon>
              <div class="texto-boton">{{ item.titulo }}</div>
            </div>
          </v-sheet> -->

          <v-sheet
            class="boton-cuadrado"
            :color="item.color"
            elevation="6"
            rounded

            :class="{
              'boton-deshabilitado':
                item.ruta === 'Horas' &&
                !usuariosPermitidosHoras.includes(usuario)
            }"

            @click="
              !(item.ruta === 'Horas' &&
              !usuariosPermitidosHoras.includes(usuario))
                && irA(item.ruta)
            "
          >

            <div class="contenido-boton text-center">

              <v-icon
                size="36"
                class="mb-2"
                color="white"
              >
                {{ item.icon }}
              </v-icon>

              <div class="texto-boton">
                {{ item.titulo }}
              </div>

            </div>

          </v-sheet>
        

        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>

import Axios from "@/axios-auth-sistemas";


export default {
  name: "MenuPrincipal",
  data() {
    return {
      botones: [
        { titulo: "Ficha OT", ruta: "FichaOT", color: "orange lighten-1", icon: "mdi-file-document" },
        { titulo: "Notas de Pedidos", ruta: "FichaNotaPedido", color: "orange lighten-1", icon: "mdi-note-outline" },
        { titulo: "Proveedor", ruta: "FichaProveedor", color: "orange lighten-1", icon: "mdi-truck" },
        { titulo: "Material", ruta: "FichaMaterialStock", color: "orange lighten-1", icon: "mdi-package-variant" },
        { titulo: "Devolucion de Material", ruta: "FichaDevolcionMaterial", color: "orange lighten-1", icon: "mdi-package-variant" },
        // { titulo: "Avance de Horas", ruta: "HorasAvanceNuevo", color: "orange lighten-1", icon: "mdi-package-variant" },
      ],

       usuario: this.$store.state.nombre,

    };

   

  },

  // computed:{
  //       usuariosPermitidosHoras(){
  //         return [
  //           "ECHEVERRIA ANAHI ARACELI",
  //           "MANSUR CECILIA BEATRIZ",
  //           "MUSSO MARCOS LUIS",
  //           "ZAMORA GUSTAVO",
  //           "HIESTAND FEDERICO"
  //         ]
  //       },



  // },    
  
  
  methods: {
    
    irMenuInge() {     
      this.$router.push({ name: "Menu" });
    },
    

    irA(nombreRuta) {
      
       
      if(nombreRuta === "HorasAvanceNuevo"){

        try{

           Axios              
                .get("/Horas/getHorasPermisos?", {
                params: {

                usuario: this.$store.state.nombre
            
                
                },

            })
            .then(r => {  

                 this.$router.push({ name: "HorasAvanceNuevo" })

            
            }).catch(r => {        
               this.$swal(
                  "",
                  "No tiene permisos para ingresar",
                  "warning"
                )
            });

        }
        catch(error){

          this.$swal(
                  "",
                  "No tiene permisos para ingresar",
                  "warning"
                )

        }

        return
      }

      switch (nombreRuta) {
        case "FichaOT":
          this.$router.push({ name: "FichaOT", params: { id: 123 } });
          break;
        case "FichaNotaPedido":
          this.$router.push({ name: "FichaNotaPedido" });
          break;
        case "FichaMaterialStock":
          this.$router.push({ name: "FichaMaterialStock" });
          break;
        case "FichaProveedor":
          this.$router.push({ name: "FichaProveedor" });
          break;
        case "FichaDevolcionMaterial":
          this.$router.push({ name: "FichaDevolcionMaterial" });
          break; 
       case "HorasAvanceNuevo":   
          this.$router.push({ name: "HorasAvanceNuevo" });
          break;     
        default:
          console.warn("Ruta desconocida:", nombreRuta);
      }
    },







  },
};
</script>

<style scoped>
.boton-cuadrado {
  width: 180px;
  height: 140px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: 0.3s ease;
}
.boton-cuadrado:hover {
  transform: scale(1.05);
}
.texto-boton {
  color: white;
  font-size: 18px;
  font-weight: bold;
  text-align: center;
  padding: 8px;
}
.cerrar-boton-container {
  position: absolute;
  top: 10px;
  right: 16px;
  z-index: 999;
}
.contenido-boton {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.boton-deshabilitado{

  opacity: 0.4;

  pointer-events: none;

  cursor: not-allowed;

}
</style>
